export enum ScreeningReportDateField {
    ARRIVAL = 'ARRIVAL',
    DEPARTURE = 'DEPARTURE',
    COMPLETED = 'COMPLETED',
    REVIEWED = 'REVIEWED'
}
